<template>
<div>
  <button @click="abrirModal" type="button" class="btn btn-primary btn-sm">
    <app-svg-symbol width="16"  name="@escavador/refresh"></app-svg-symbol>
  </button>
  <modal-confirmar-novo-token-callback
    :visible="showModal"
    v-if="this.showModal"
    @closeModal="closeModal">
  </modal-confirmar-novo-token-callback>
</div>
</template>

<script>
import ModalConfirmarNovoTokenCallback
  from "./ModalConfirmarNovoTokenCallback.vue";

export default {
  name: "BotaoConfirmarNovoTokenCallback",
  components:{
    ModalConfirmarNovoTokenCallback,
  },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    abrirModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
}
</script>

<style scoped>

</style>
